import React, { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';

// label/placeholderManual: opcionales, para reutilizar este mismo escáner
// fuera del material de almacén (p.ej. el nº de serie de un equipo) sin
// cambiar el comportamiento de las pantallas que ya lo usan tal cual.
export default function BarcodeScanner({ onScan, onClose, label = 'Apunta al código de barras del producto', placeholderManual = 'O introduce el EAN manualmente' }) {
  const videoRef    = useRef(null);
  const controlsRef = useRef(null);
  const [error,     setError]   = useState('');
  const [scanning,  setScanning] = useState(false);
  const [manual,    setManual]   = useState('');

  useEffect(() => {
    let cancelled = false;
    const reader = new BrowserMultiFormatReader();

    const start = async () => {
      try {
        const controls = await reader.decodeFromConstraints(
          { video: { facingMode: 'environment', width: { ideal: 1280 }, height: { ideal: 720 } } },
          videoRef.current,
          (result, err, ctrl) => {
            if (cancelled) return;
            if (result) {
              ctrl.stop();
              onScan(result.getText());
            }
          }
        );
        if (cancelled) { controls.stop(); return; }
        controlsRef.current = controls;
        setScanning(true);
      } catch (e) {
        if (!cancelled) setError('No se pudo acceder a la cámara. Comprueba los permisos.');
      }
    };

    start();

    return () => {
      cancelled = true;
      controlsRef.current?.stop();
    };
  }, [onScan]);

  const handleManual = (e) => {
    e.preventDefault();
    if (manual.trim()) onScan(manual.trim());
  };

  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col">
      <div className="relative flex-1 overflow-hidden">
        <video
          ref={videoRef}
          className="w-full h-full object-cover"
          muted
          playsInline
        />

        {scanning && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-64 h-32 relative">
              {[
                'top-0 left-0 border-t-4 border-l-4 rounded-tl-lg',
                'top-0 right-0 border-t-4 border-r-4 rounded-tr-lg',
                'bottom-0 left-0 border-b-4 border-l-4 rounded-bl-lg',
                'bottom-0 right-0 border-b-4 border-r-4 rounded-br-lg',
              ].map((cls, i) => (
                <div key={i} className={`absolute w-8 h-8 border-white ${cls}`} />
              ))}
              <div className="absolute left-4 right-4 h-0.5 bg-red-500 opacity-80 animate-scan-line" style={{ top: '50%' }} />
            </div>
          </div>
        )}

        {error && (
          <div className="absolute inset-x-4 top-4 bg-red-900/80 text-white text-sm rounded-xl px-4 py-3 text-center">
            {error}
            <form onSubmit={handleManual} className="flex gap-2 mt-3">
              <input
                type="text"
                value={manual}
                onChange={e => setManual(e.target.value)}
                placeholder="EAN manual"
                className="flex-1 text-sm border border-white/30 bg-white/10 text-white placeholder-white/50 rounded-lg px-3 py-2 focus:outline-none"
              />
              <button type="submit" className="px-3 py-2 bg-white text-gray-900 rounded-lg font-bold text-sm">OK</button>
            </form>
          </div>
        )}

        {scanning && !error && (
          <div className="absolute bottom-24 left-0 right-0 text-center">
            <p className="text-white text-sm font-medium bg-black/40 px-4 py-2 rounded-full mx-auto inline-block">
              {label}
            </p>
          </div>
        )}
      </div>

      <div className="bg-gray-900 px-4 py-4 space-y-3">
        <form onSubmit={handleManual} className="flex gap-2">
          <input
            type="text"
            value={manual}
            onChange={e => setManual(e.target.value)}
            placeholder={placeholderManual}
            className="flex-1 text-sm bg-gray-800 text-white border border-gray-600 rounded-xl px-3 py-2.5 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-400"
          />
          <button type="submit" disabled={!manual.trim()} className="px-4 py-2 bg-red-600 disabled:opacity-40 text-white rounded-xl font-bold text-sm">
            OK
          </button>
        </form>
        <button
          onClick={onClose}
          className="w-full py-3 bg-gray-700 hover:bg-gray-600 text-white font-semibold rounded-xl text-sm transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
